module.exports = __webpack_public_path__ + "img/crv.ee1e9920.png";